
import { Component, Vue, Prop } from "vue-property-decorator";
import { getTongueResult } from "@/api/open";



@Component({
    components: {
    }
})
export default class OpenTongueCollectStep2 extends Vue {
    @Prop({ default: "" }) reportId: string;

    timer = null;

    destroyed() {
        clearInterval(this.timer);
    }

    checkResult() {
        console.log("checkResult", this.reportId);
        if (!this.reportId) {
            this.$confirm("未检测到舌面信息，请重新扫码检测", "提示", {
                confirmButtonText: "确定",
                type: "warning"
            }).finally(() => {
                clearInterval(this.timer);
                this.$emit("restart");
            });
            return;
        }
        getTongueResult({ id: this.reportId }).then((res: any) => {
            console.log("res", res)
            const {code, data } = res.data;
            if (code) {
                switch (code) {
                    case "0000":
                        clearInterval(this.timer);
                        this.$emit("goResult");
                    return;
                        case "201":
                        break;
                    default:
                        clearInterval(this.timer);
                        this.$emit("goResultError");
                        return;
                }
            }
        });
    }

    startCheckResult() {
        this.timer = setInterval(() => {
            this.checkResult();
        }, 5000);
    }
}
